// 英文
import enLocale from 'element-ui/lib/locale/lang/en'


const en = {
  // ============= 登录 start ============
  "验证码": "Verification Code",
  "登录": "Login",
  "请输入验证码": "Please enter the verification code",
  "验证码不正确!": "Incorrect verification code!",
  "请输入账号": "Please enter your account",
  "请输入密码": "Please enter your password",
  "访问地址有误，请在shop后台核实": "The access address is incorrect, please verify in the shop backend",
  // ============= 登录 end ============

  // ============= Layout start ============
  "全屏模式": "Full Screen Mode",
  "首页": "Home",
  "此操作将退出登录, 是否继续?": "This operation will log out, do you want to continue?",
  "已取消退出": "Logout cancelled",
  "您有一个新订单": "You have a new order",
  "无法获取当前门店信息，请重新登录": "Unable to retrieve current store information, please log in again",
  "收银台": "Checkout Counter",
  "收银": "Checkout",
  "桌台": "Table",
  "订单": "Order",
  // ============= Layout end  ============

  // ============= 首页 start ============
  "查询会员": "Search Member",
  "商品改价": "Change Price",
  "商品删行": "Delete Item",
  "整单取消": "Cancel Order",
  "取单": "Fetch Order",
  "挂单": "Hold Order",
  "折扣": "Discount",
  "抹零": "Round Off",
  "请输入内容": "Please enter content",
  "收银员": "Cashier",
  "店内就餐": "Dine-In",
  "打包带走": "Takeout",
  "商品名称": "Item Name",
  "商品价格": "Item Price",
  "商品数量": "Item Quantity",
  "应收": "Total Payable",
  "包装费": "Packaging Fee",
  "优惠": "Discount",
  "数量": "Quantity",
  "件": "Piece",
  "实收": "Amount Received",
  "收款": "Receive Payment",
  "请选择商品": "Please select items",
  "确定要删除": "Are you sure you want to delete",
  "提示": "Tip",
  "确定": "Confirm",
  "取消": "Cancel",
  "请先将购物车内的商品挂单或结账后再取单": "Please hold or checkout items in the shopping cart before fetching the order",
  "确定要整单取消吗?": "Are you sure you want to cancel the order?",
  "请输入会员手机号查询会员，输入完毕后点击确认": "Please enter the member's phone number to search, then click confirm",
  "请输入会员手机号": "Please enter the member's phone number",
  "会员昵称": "Member Nickname",
  "余额总计": "Total Balance",
  "退出": "Exit",
  "该用户不存在": "This user does not exist",
  "折扣抹零": "Discount/Round Off",
  "当前价格": "Current Price",
  "改价": "Change Price",
  "实付价格": "Actual Price",
  "请输入实付价格": "Please enter the actual price",
  "优惠折扣": "Discount Rate",
  "请输入优惠折扣": "Please enter the discount rate",
  "抹分": "Round Down to Nearest Tenth",
  "抹角": "Round Down to Nearest Dollar",
  "四舍五入到角": "Round to Nearest Tenth",
  "四舍五入到元": "Round to Nearest Dollar",
  "确 定": "Confirm",
  "价格不能为空": "Price cannot be empty",
  "折扣不能为空": "Discount cannot be empty",
  "修改价格": "Modify Price",
  "本次售价": "Current Selling Price",
  "请输入本次售价": "Please enter the current selling price",
  "清空": "Clear",
  "确认": "Confirm",
  "商品详情": "Item Details",
  "单位": "Unit",
  "规格": "Specifications",
  "加料": "Additional Ingredients",
  "取 消": "Cancel",
  "现金收款": "Cash Payment",
  "余额收款": "Balance Payment",
  "其他方式": "Other Methods",
  "应收金额": "Total Amount Due",
  "用户通过店内扫码等方式进行支付，确认用户支付成功后，点击确认付款即可完成付款操作。": "Customers can make payment using in-store QR code and other methods. After confirming successful payment, click 'Confirm Payment' to complete the transaction.",
  "微信支付": "WeChat Pay",
  "支付宝支付": "Alipay",
  "pos刷卡": "POS Card Payment",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Please enter the member ID to search for the member, then click confirm",
  "请输入会员ID": "Please enter the member ID",
  "登录会员仅作为积分累计，无法享受其他优惠。": "Logged-in members can only accumulate points and are not eligible for other discounts.",
  "取消收款": "Cancel Payment",
  "订单总价": "Total Order Price",
  "挂单时间": "Order Hold Time",
  "删除": "Delete",
  "多语言小票打印": "Multilingual Receipt Printing",
  "打印语言": "Print Language",
  "中文": "Chinese",
  "英语": "English",
  "德语": "German",
  "法语": "French",
  "西班牙语": "Spanish",
  "意大利语": "Italian",
  "克罗地亚": "Croatian",
  "斯洛文尼亚": "Slovenian",
  "匈牙利语": "Hungarian",
  "塞尔维亚语": "Serbian",
  // ============= 首页 end   ============

  // ============= 桌台 start ============
  "未开台": "Not Opened",
  "已开台": "Table Opened",
  "就餐中": "Dining",
  "刷新": "Refresh",
  "整单清空": "Clear Entire Order",
  "转台": "Change Table",
  "打印预结单": "Print Preliminary Bill",
  "催菜": "Expedite Order",
  "人数": "Number of Guests",
  "订单来源": "Order Source",
  "请点击左侧桌号台": "Please click on the table number on the left",
  "点选已开台桌台，可以在此查看点餐信息。": "Select an open table to view ordering details here.",
  "服务费": "Service Charge",
  "税费": "Tax",
  "协助点餐": "Assist in Ordering",
  "协助加餐": "Assist in Adding Items",
  "结账": "Check Out",
  "完成": "Complete",
  "价格": "Price",
  "请选择": "Please Select",
  "确定要打印小票吗?": "Are you sure you want to print the receipt?",
  "确定要关闭桌台并取消订单吗?": "Are you sure you want to close the table and cancel the order?",
  "请选择桌号": "Please select a table number",
  "就餐人数": "Number of Diners",
  "下单": "Place Order",
  "返回": "Back",
  "确定要商品删行吗?": "Are you sure you want to delete the item row?",
  "请选择就餐人数": "Please select the number of diners",
  // ============= 桌台 end ============

  // ============= 订单 start ============
  "下单时间": "Order Time",
  "起始时间": "Start Time",
  "店内订单": "In-Store Order",
  "自提订单": "Pick-up Order",
  "外卖订单": "Delivery Order",
  "名称": "Name",
  "支付时间": "Payment Time",
  "消费方式": "Payment Method",
  "状态": "Status",
  "单价": "Unit Price",
  "金额": "Amount",
  "税率": "Tax Rate",
  "税费金额": "Tax Amount",
  "邮箱地址": "Email Address",
  "今天": "Today",
  "昨天": "Yesterday",
  "一周": "One Week",
  "搜索": "Search",
  "待完成": "To be Completed",
  "已完成": "Completed",
  "已取消": "Cancelled",
  "全部": "All",
  "顾客信息": "Customer Information",
  "用户昵称": "User Nickname",
  "手机号": "Phone Number",
  "收货地址": "Delivery Address",
  "取单号": "Order Pickup Number",
  "就餐方式": "Dining Method",
  "订单号": "Order Number",
  "订单金额": "Order Amount",
  "订单优惠": "Order Discount",
  "实付金额": "Actual Amount Paid",
  "支付方式": "Payment Method",
  "备注信息": "Remarks",
  "期望配送时间": "Expected Delivery Time",
  "取餐时间": "Pick-up Time",
  "配送费": "Delivery Fee",
  "退款金额": "Refund Amount",
  "准备中": "Preparing",
  "出餐中": "Cooking",
  "待取餐": "Waiting for Pick-up",
  "订单信息": "Order Information",
  "税费详情": "Tax Details",
  "取消订单": "Cancel Order",
  "打印小票": "Print Receipt",
  "出餐": "Serve Dishes",
  "确认送达": "Confirm Delivery",
  "退款": "Refund",
  "已退款": "Refunded",
  "请输入订单号": "Please enter the order number",
  "至": "To",
  "开始日期": "Start Date",
  "结束日期": "End Date",
  "发送账单": "Send Bill",
  "请输入邮箱地址": "Please enter your email address",
  "确定要催菜吗?": "Are you sure you want to expedite the order?",
  "确定要完成订单吗?": "Are you sure you want to complete the order?",
  "确定要出餐吗?": "Are you sure you want to serve the dishes?",
  "确定要发送账单吗?": "Are you sure you want to send the bill?",
  "邮箱不能为空": "Email cannot be empty",
  "确定要取消订单吗?": "Are you sure you want to cancel the order?",
  "是否确认此操作?": "Are you sure you want to confirm this operation?",
  "上传文件只能是excel格式!": "Uploaded file must be in Excel format!",
  "上传文件大小不能超过 10MB!": "Uploaded file size cannot exceed 10MB!",
  "正在处理,请等待": "Processing, please wait",
  "本次处理失败": "Processing failed this time",
  "总金额": "Total Amount",
  "可退款金额": "Refundable Amount",
  "请输入退款金额": "Please enter the refund amount",
  "超出可退款金额": "Exceeds the refundable amount",
  "404错误页面": "404 Error Page",
  "合计": "Total",
  "份": "Portion",
  "余额支付": "Balance Payment",
  "线下支付(现金支付)": "Offline Payment (Cash Payment)",
  "线下支付(自有微信支付)": "Offline Payment (WeChat Payment)",
  "线下支付(自有支付宝支付)": "Offline Payment (Alipay Payment)",
  "线下支付(POS刷卡支付)": "Offline Payment (POS Card Payment)",
  "进行中": "In Progress",
  "待付款": "Pending Payment",
  "待配送": "Awaiting Delivery",
  "配送中": "In Delivery",
  "待接单": "Awaiting Acceptance",
  "待取货": "Waiting for Pickup",
  "已配送": "Delivered",
  "已收货": "Received",
  "待收货": "To Receive",
  "待取消": "To Cancel",
  "会员": "Member",
  "商家": "Merchant",
  "供应商": "Supplier",
  "分销": "Distribution",
  "通知": "Notification",
  "已付款": "Paid",
  "用户下单": "User Placed Order",
  "收银台下单": "Checkout Counter Order",
  "扫码下单": "Scan to Order",
  "团购下单": "Group Buying Order",
  "商城订单": "Mall Order",
  "积分商城订单": "Points Mall Order",
  "余额充值订单": "Balance Recharge Order",
  "购卡订单": "Card Purchase Order",
  "券包订单": "Voucher Pack Order",
  "配送员押金订单": "Delivery Personnel Deposit Order",
  "团购订单": "Group Purchase Order",
  "下单减库存": "Decrease Inventory on Order",
  "付款减库存": "Decrease Inventory on Payment",
  "商家配送": "Merchant Delivery",
  "外卖配送": "Takeout Delivery",
  "到店自提": "In-store Pickup",
  "快递配送": "Courier Delivery",
  "个人中心": "Personal Center",
  ...enLocale
}

export default en



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js